module.exports = __webpack_public_path__ + "img/sms.a5e54758.webp";